<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="materia" titulo="Materia / Coordinación académica" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('materias', 'materia', 'filtrar');"></a>
                    <a id="filtrar" (click)="filtrar(ctrl.materias);"></a>

                    <div class="columns">
                        <div class="column">
                            <label class="label">Nombre:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}" placeholder="Nivel" formControlName="nombre">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">Clave:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('clave').hasError('required')}" placeholder="Clave" formControlName="clave">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('clave').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                          <label class="label">Orden:</label>
                          <p class="control has-icons-left has-icons-right">
                              <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('orden').hasError('required')}" placeholder="Orden" formControlName="orden">
                              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('orden').hasError('required')">
                              <i class="fa fa-warning"></i>
                          </span>
                              <span class="help is-danger" *ngIf="ctrl.dato.get('orden').hasError('required')">Este campo es requerido.</span>
                          </p>
                      </div>
                    </div>

                    <div class="columns">
                        <div class="column is-3">
                            <label class="label">Nivel:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('nivel').hasError('required')}" placeholder="Nivel" formControlName="nivel">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel').hasError('required')">
                              <i class="fa fa-warning"></i>
                          </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nivel').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">HD:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('hd').hasError('required')}" placeholder="HD" formControlName="hd">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hd').hasError('required')">
                              <i class="fa fa-warning"></i>
                          </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('hd').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">HI:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('hi').hasError('required')}" placeholder="HI" formControlName="hi">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hi').hasError('required')">
                            <i class="fa fa-warning"></i>
                        </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('hi').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">Créditos:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('creditos').hasError('required')}" placeholder="Créditos" formControlName="creditos">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('creditos').hasError('required')">
                          <i class="fa fa-warning"></i>
                      </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('creditos').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                    </div>

                    <div class="content">
                        <hr>
                        <span class="subtitle has-text-primary">
                          <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i>
                          Seriación de materia
                      </span>
                    </div>
                    <div>
                        <label class="label">Materia anterior:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select">
                              <!-- <select class="select" name="materia_anterior" formControlName="materia_anterior">
                                <option *ngFor="let val of materias_anteriores" value="{{val.id}}">{{ val.nombre }}</option>
                              </select> -->
                              <ng-select2
                                  [disabled]="materias_anteriores ? materias_anteriores.length == 0 ? true : false : true"
                                  name="materia_anterior_id"
                                  formControlName="materia_anterior_id"
                                  [options]="ctrl.optionSelect"
                                  [value]="ctrl.dato.controls.materia_anterior_id.value"
                                  [data]="materias_anteriores"></ng-select2>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="field">
                        <label class="label">Nivel:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nivel').hasError('required')}" placeholder="Nivel" formControlName="nivel">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nivel').hasError('required')">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">Periodo Escolar:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('periodos_escolares_id').hasError('required')}">
                                <select class="select" name="periodos_escolares_id" formControlName="periodos_escolares_id">
                                    <option *ngFor="let val of ctrl.periodos_escolares" value="{{val.id}}">{{ val.nombre }}</option>
                                </select>
                            </div>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">Este campo es requerido.</span>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Plan:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('carreras_planes_id').hasError('required')}">
                                <select class="select" name="carreras_planes_id" formControlName="carreras_planes_id">
                                    <option *ngFor="let val of ctrl.carreras_planes" value="{{val.id}}">{{ val.carreras.nombre }} / {{ val.planes_estudios.nombre }}</option>
                                </select>
                            </div>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">Este campo es requerido.</span>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Observaciones:</label>
                        <p class="control has-icons-left has-icons-right">
                            <textarea class="input" type="text" placeholder="Observaciones" formControlName="observaciones"></textarea>
                        </p>
                    </div> -->

                </section>
            </form>
        </div>
    </div>
</div>
